<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Cadastro de Frota - Motorista</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Cadastrar Motorista"
          icon="assets/add.svg"
          (click)="navegarMotorista()"></app-botao>
        <app-botao
          type="upload"
          class="button"
          text="Enviar Planilha"
          icon="assets/add-excel.svg"
          (fileSelected)="uploadArquivo($event)"></app-botao>
        <app-botao
          type="secundario"
          class="button"
          [ariaPlaceholder]="'Baixar modelo'"
          width="40px"
          icon="assets/download.svg"
          (click)="this.downloadExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Motoristas<br /></div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getMotorista()">
            <div class="table-filters">
              <app-input
                label="Nome do motorista:"
                placeholder="Pesquisar "
                name="NM_USUA_MTRT"
                formControlName="NM_USUA_MTRT"
                width="100%"></app-input>
              <app-input
                label="CPF:"
                width="100%"
                placeholder="Pesquisar"
                name="TX_CPF_MTRT"
                formControlName="TX_CPF_MTRT"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Nome do motorista:"
        placeholder="Pesquisar "
        name="NM_USUA_MTRT"
        formControlName="NM_USUA_MTRT"
        width="100%"></app-input>
      <app-input
        label="CPF:"
        width="100%"
        placeholder="Pesquisar"
        name="TX_CPF_MTRT"
        formControlName="TX_CPF_MTRT"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
<app-loader [isLoading]="isLoading"></app-loader>
